/**
 * Basic resource form add/edit controller.
 *
 * Extends a resource form controller class.
 *
 * @example
 * export class MyResourceFormClass extends tmrResourceFormController {
 *   ...
 * }
 * @type {ngController}
 */
export class tmrResourceFormController {
  static ngType = 'controller'

  constructor($scope, $state, $stateParams, TmrInvalidFormError, TmrToast) {
    'ngInject'
    Object.assign(this, {
      $scope,
      $state,
      $stateParams,
      TmrInvalidFormError,
      TmrToast,
    })
  }

  $onInit() {
    this.op = this.$stateParams.op
    // If redirect binding is not present, set automatically:
    // add forms are siblings of the list route; edit forms are nephews.
    this.redirect = this.$stateParams.redirect
      ? this.$stateParams.redirect
      : this.op == 'add'
      ? '^.list'
      : '^.^.list'

    //Set submitAndContinue default value
    this.submitAndContinue = !!this.$stateParams.submitAndContinue
  }

  onCancel() {
    return this.$state.go(this.redirect)
  }

  validate() {
    return new Promise((resolve, reject) => {
      if (this.$scope.resourceForm.$valid) resolve()
      else {
        this.$scope.resourceForm.$setSubmitted()
        reject(new this.TmrInvalidFormError())
      }
    })
  }

  onSubmit() {
    return this.validate()
      .then(() => this.save())
      .then(() => this.onSaved())
      .catch(err =>
        this.TmrToast.exception(err, !(err instanceof this.TmrInvalidFormError))
      )
  }

  onSubmitContinue() {
    return this.validate()
      .then(() => this.save())
      .then(() => this.onSavedContinue())
      .catch(err =>
        this.TmrToast.exception(err, !(err instanceof this.TmrInvalidFormError))
      )
  }

  /**
   * Saves the resource.
   * Overrides this when extending the controller to hook into the save process after the form is submitted.
   */
  save() {
    return this.resource.$save()
  }

  onSaved() {
    return this.$state
      .go(this.redirect, null, { reload: true, inherit: false })
      .then(this.TmrToast.success(this.toast))
  }

  onSavedContinue() {
    return this.$state
      .go(
        this.$state.current,
        { submitAndContinue: true },
        { reload: true, inherit: false }
      )
      .then(this.TmrToast.success(this.toast))
  }

  addAttribute(key, value) {
    this.resource.attributes = this.resource.attributes ?? {}
    this.resource.attributes[key] = value
  }

  removeAttribute(key) {
    delete this.resource.attributes[key]
  }

  submitContinue() {
    this.submitAndContinue = !this.submitAndContinue
  }
}
